import React, { Component } from 'react';
import { Alert } from 'react-bootstrap';

export default class AlertComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: true
        };
    }
    render() {
        const { show, type, handleDismiss, message } = this.props;
        if (this.props.show) {
            return (
                <Alert variant={this.props.type} onClose={handleDismiss} dismissible>
                    <p>
                        {this.props.message}
                    </p>
                </Alert>
            );
        }
        return ""
    }
}